<template>
  <v-container fluid>
    <v-row v-if="student">
      <v-col cols="12" md="6">
        <v-card>
          <v-toolbar dense flat color="blur">Base info</v-toolbar>
          <v-divider/>
          <v-list>
            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-account</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Nickname</v-list-item-subtitle>
                <v-list-item-title>{{ student.nickname }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-email</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Sign-in email</v-list-item-subtitle>
                <v-list-item-title>{{ student.email }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-map-marker</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Address</v-list-item-subtitle>
                <v-list-item-title>{{ student.country }} {{ student.address }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-video</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Zoom Personal Meeting ID</v-list-item-subtitle>
                <v-list-item-title>{{ student.zoom_id }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-linkedin</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>LinkedIn</v-list-item-subtitle>
                <v-list-item-title>{{ student.linked_in }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-skype</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Skype</v-list-item-subtitle>
                <v-list-item-title>{{ student.skype }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">
            Issues
            <v-spacer/>
            <v-btn icon @click="openCreateIssueDialog"><v-icon>mdi-plus</v-icon></v-btn>
          </v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-chip color="primary" class="ma-1 box-shadow" v-for="(item, idx) in student.issues" :key="idx">
              <v-avatar left>
                <v-icon>mdi-account-circle</v-icon>
              </v-avatar>
              {{ item.type}}

              <v-btn icon @click="deleteIssue(item)"><v-icon>mdi-close</v-icon></v-btn>
            </v-chip>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">Session limits</v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-chip color="primary" class="ma-1 box-shadow" v-for="(item, idx) in student.session_limits" :key="idx">
              {{ item.name}} - {{ item.count}}
            </v-chip>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">Summary</v-toolbar>
          <v-divider/>
          <v-card-text class="ql-editor" v-html="student.summary"></v-card-text>
        </v-card>

        <v-dialog v-model="create_issue_dialog" @click:outside="closeCreateIssueDialog" max-width="400px">
          <v-card v-if="create_issue">
            <v-toolbar dark dense color="primary">Create issue</v-toolbar>
            <v-card-text class="pt-3">
              <v-select v-model="create_issue.type" :items="issue_options" hide-details outlined></v-select>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn block :disabled="!create_issue.type" @click="createIssue" color="success">Create</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    issue_options: [
      { value: 'anxiety', text: 'Anxiety'},
      { value: 'language', text: 'Language'},
      { value: 'bad_character', text: 'Bad character'},
      { value: 'coming_late', text: 'Coming late'},
      { value: 'aggressive', text: 'Aggressive'},
      { value: 'too_many_questions', text: 'Too many questions'},
      { value: 'alien', text: 'Alien'},
      { value: 'it_ignorant', text: 'IT Ignorant'},
      { value: 'talkative', text: 'Talkative'},
    ],
    create_issue: null,
    create_issue_dialog: false,
  }),
  mounted() {

  },
  methods: {
    openCreateIssueDialog() {
      this.create_issue = {
        type: 'anxiety',
        body: ''
      }
      this.create_issue_dialog = true
    },
    closeCreateIssueDialog() {
      this.create_issue_dialog = false
      this.create_issue = null
    },
    createIssue() {
      this.app_loading = true
      this.axios.post(`api/students/${this.$route.params.student_id}/issues`, this.create_issue)
        .then(({data}) => {
          this.student.issues.push(data.data)
          this.closeCreateIssueDialog()
        })
        .catch(errors => {console.log(errors.response.data.errors)})
        .then(() => {this.app_loading = false})

    },
    deleteIssue(selected) {
      this.axios.delete(`api/students/${this.$route.params.student_id}/issues`, {
        params: {issue_id: selected.id}
      })
          .then(() => {this.$emit('loadStudent')})
    }
  }

}
</script>